export default __webpack_public_path__ + "static/media/13.966e57a3.png";